<template>
    <div v-show="true" class="char-count">
      <span :class="klass"><small>You have {{charsLeft}} of {{maxLength}} characters remaining</small></span>
    </div>
</template>

<script>

export default {
  name: 'CharCount',
  props: {
    inputValue: String,
    maxLength: Number
  },
  data() {
    return {
     
    }
  },
  computed: {
    show() {
      return this.charsLeft < this.maxLength
    },
    charsLeft() {
      if (this.inputValue !== null && typeof(this.inputValue) != "undefined")
        return this.maxLength - this.inputValue.length

      return this.maxLength
    },
    klass() {
      if (this.charsLeft < 5) {
        return 'text-danger'
      }
      return null
    }
  }
}
</script>